var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'active':_vm.isActive},on:{"click":function($event){$event.stopPropagation();return _vm.itemClick.apply(null, arguments)}}},[_vm._t("item-second-nav-text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }